var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43563"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2342",
    cx: 30.5,
    cy: 30,
    r: 30,
    fill: "#8DC5EC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 20931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4893 25.5C19.4893 21.3579 22.8471 18 26.9893 18C31.1314 18 34.4892 21.3579 34.4892 25.5C34.4892 29.6422 31.1314 33 26.9893 33C22.8471 33 19.4893 29.6422 19.4893 25.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.1019 29.7713C35.0261 29.915 35.0582 30.0942 35.1887 30.1908C36.1581 30.9083 37.3576 31.3327 38.6561 31.3327C41.8777 31.3327 44.4894 28.721 44.4894 25.4993C44.4894 22.2777 41.8777 19.666 38.6561 19.666C37.3576 19.666 36.1581 20.0903 35.1887 20.8079C35.0582 20.9046 35.0261 21.0836 35.1019 21.2273C35.7751 22.503 36.1561 23.9567 36.1561 25.4993C36.1561 27.042 35.7751 28.4957 35.1019 29.7713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8913 35.8315C20.9453 34.94 23.6402 34.666 26.9893 34.666C30.3414 34.666 33.0382 34.9405 35.0929 35.834C37.3311 36.8072 38.6914 38.4648 39.4044 40.8053C39.7386 41.9023 38.9146 42.9993 37.7791 42.9993H16.2028C15.0659 42.9993 14.2402 41.9007 14.5754 40.8017C15.2893 38.4608 16.6517 36.8037 18.8913 35.8315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.8537 33.0609C35.1637 33.1038 35.1232 34.0308 35.7572 34.3064C37.4945 35.0619 38.8027 36.1741 39.7409 37.5936C40.5107 38.7584 41.7062 39.6669 43.1024 39.6669H46.07C47.2487 39.6669 48.1087 38.4958 47.694 37.3516C47.6702 37.2858 47.6454 37.2204 47.6197 37.1556C47.049 35.7146 46.0709 34.6538 44.6225 33.9776C43.2627 33.3428 41.5604 33.0808 39.5549 33.0016L39.5219 33.0003H39.489C38.3077 33.0003 37.0739 32.9851 35.8537 33.0609Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.a59a6d2513e8d8a53e0f0f7930d00102.svg";
export { ForwardRef as ReactComponent };